import './layout.scss';

export type LayoutProps = {
  children: React.JSX.Element;
};

export const Layout = ({ children }: LayoutProps) => {
  return (
    <div className="layout-container">
      <div data-testid="layout" className="layout">
        {children}
      </div>
    </div>
  );
};
